import React from 'react';
function useOnUpdate({ cb = () => void 0, condition, hash }) {
    React.useEffect(() => {
        if (condition) {
            cb();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hash, condition]);
}
export default useOnUpdate;
